import React, { useState, memo, useEffect, useCallback } from 'react';
import Table from "components/Table";

import { CTeInvoicingItemsProps } from './interface';

import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import { IBatchRequestResponse } from 'models/Batch';
import { CTeInvoiceItems } from 'models/CTEs';
import CteServices from 'services/cte.service';

const CTeInvoicingItems: React.FC<CTeInvoicingItemsProps> = (props) => {

  const { model, cteInvoice } = props;

  const pageSize = 5;

  const [cteInvoiceItems, setCteInvoiceItems] = useState<IBatchRequestResponse<CTeInvoiceItems>>();
  const [tableItemOrderBy, setTableItemOrderBy] = useState("");
  const [currentPageItem, setCurrentPageItem] = useState(0);

  const cteService = new CteServices();

  useEffect(() => {
    getCTeInvoiceItems();
  }, [currentPageItem, tableItemOrderBy]);

  const getCTeInvoiceItems = useCallback(() => {
    setCteInvoiceItems(undefined);

    cteService
      .getInvoiceItemsCTe(currentPageItem, pageSize, tableItemOrderBy, cteInvoice?.id)
      .then((result: IBatchRequestResponse<CTeInvoiceItems> | undefined) => {
        if (result) {
          const { error, data, totalPages, pageSize, total } = result;
          setCteInvoiceItems({ error, data, totalPages, pageSize, total });
        }
      });
  }, [currentPageItem, tableItemOrderBy]);

  return (
    <Column className="animated fadeIn px-md-2 px-3 py-2 bg-white overflow-x-auto">

      <Row id="info-table-cte-items" >
        <Row className="payment-breakpoint">
          <Text className="d-block font-bold color-blue-gray mt-2 mb-1" size={12}>
            Detalhamento da fatura
          </Text>
        </Row>
      </Row>

      <Table
        trackingKey="Visualizar Itens Fatura CTe"
        setTableOrder={setTableItemOrderBy}
        tableOrder={tableItemOrderBy}
        error={cteInvoiceItems?.error || false}
        onReload={getCTeInvoiceItems}
        currentPage={currentPageItem}
        data={cteInvoiceItems?.data}
        pageSize={pageSize}
        onPageChange={setCurrentPageItem}
        totalPages={cteInvoiceItems?.totalPages}
        model={model}
        completeBlankSpaces={false}
        rowHeight={40}
        customProps={{ cteInvoiceId: cteInvoice.identifier }}
        className="mb-1"
      />
    </Column>
  );
};

export default memo(CTeInvoicingItems);
